// import { formatMoney } from 'utils';

// if (window.theme?.sitewide_sale_enabled) {
//   const percentage = window.theme.sitewide_sale_percentage || 0;

//   function calculateSalePrice(price) {
//     return Math.round(price - (price * percentage) / 100);
//   }

//   function buildPdpPriceHTML(variant) {
//     const salePrice = calculateSalePrice(variant.price);
//     const saleFormatted = formatMoney(salePrice, window.theme.money_product_price_format);
//     const originalFormatted = formatMoney(variant.price, window.theme.money_product_price_format);

//     return `
//       <span class="u-hidden-visually">${window.theme.localize('REGULAR_PRICE')}</span>
//       <span class="price__number price__number--sale">
//         <span class="money">${saleFormatted}</span>
//       </span>
//       <span class="u-hidden-visually">${window.theme.localize('SALE_PRICE')}</span>
//       <s class="price__compare">
//         <span class="money">${originalFormatted}</span>
//       </s>
//     `;
//   }

//   function updateSitewideSalePrices(variant, uniqueId) {
//     const priceEl = document.getElementById(`price-${uniqueId}`);
//     if (priceEl) {
//       priceEl.innerHTML = buildPdpPriceHTML(variant);
//     }

//     const saleFormatted = formatMoney(calculateSalePrice(variant.price), window.theme.money_product_price_format);

//     document.querySelectorAll('.price-new-wrap .price-atc-wrap').forEach((el) => {
//       el.textContent = saleFormatted;
//     });

//     document.querySelectorAll('.title-price-on-top-wrapper .price__number .money').forEach((el) => {
//       el.textContent = saleFormatted;
//     });
//   }

//   document.addEventListener('on:variant:change', (event) => {
//     const variant = event.detail?.variant;
//     const target = event.target;
//     if (!variant || !target) return;

//     const uniqueId = target.dataset.card || target.dataset.section;
//     if (!uniqueId) return;

//     setTimeout(() => updateSitewideSalePrices(variant, uniqueId), 0);
//   });
// }


// import { formatMoney } from 'utils';

// if (window.theme?.sitewide_sale_enabled) {
//   const percentage = window.theme.sitewide_sale_percentage || 0;

//   function calculateSalePrice(price) {
//     return Math.round(price - (price * percentage) / 100);
//   }

//   function buildPdpPriceHTML(variant) {
//     const salePrice = calculateSalePrice(variant.price);
//     const saleFormatted = formatMoney(salePrice, window.theme.money_product_price_format);
//     const originalFormatted = formatMoney(variant.price, window.theme.money_product_price_format);

//     return `
//       <span class="u-hidden-visually">${window.theme.localize('REGULAR_PRICE')}</span>
//       <span class="price__number price__number--sale">
//         <span class="money">${saleFormatted}</span>
//       </span>
//       <span class="u-hidden-visually">${window.theme.localize('SALE_PRICE')}</span>
//       <s class="price__compare">
//         <span class="money">${originalFormatted}</span>
//       </s>
//     `;
//   }

//   function updateSitewideSalePrices(variant, uniqueId) {
//     if (!variant) return;

//     const saleHTML = buildPdpPriceHTML(variant);
//     const saleFormatted = formatMoney(calculateSalePrice(variant.price), window.theme.money_product_price_format);

//     document.querySelectorAll(`#price-${uniqueId}, [id="price-${uniqueId}"]`).forEach((priceEl) => {
//       priceEl.innerHTML = saleHTML;
//     });

//     document.querySelectorAll('.price-new-wrap .price-atc-wrap').forEach((el) => {
//       el.textContent = saleFormatted;
//     });

//     document.querySelectorAll('.title-price-on-top-wrapper .price__number .money').forEach((el) => {
//       el.textContent = saleFormatted;
//     });
//   }

//   function getVariantFromControl(control) {
//     if (typeof control.getVariantData !== 'function') return null;

//     const variants = control.getVariantData();
//     if (!variants?.length) return null;

//     if (typeof control.currentVariant !== 'undefined' && control.currentVariant) {
//       return control.currentVariant;
//     }

//     const options = Array.from(control.querySelectorAll('select')).map((select) => select.value);
//     if (options.length) {
//       return variants.find((variant) => !variant.options.map((value, index) => options[index] === value).includes(false));
//     }

//     const fieldsets = Array.from(control.querySelectorAll('fieldset'));
//     if (fieldsets.length) {
//       const selectedOptions = fieldsets.map(
//         (fieldset) => Array.from(fieldset.querySelectorAll('input')).find((input) => input.checked)?.value,
//       );
//       return variants.find(
//         (variant) => !variant.options.map((value, index) => selectedOptions[index] === value).includes(false),
//       );
//     }

//     return variants.find((variant) => variant.available) || variants[0];
//   }

//   function syncProductPagePrices() {
//     document.querySelectorAll('variant-selects, variant-radios, variant-mixed-inputs').forEach((control) => {
//       const uniqueId = control.dataset.card || control.dataset.section;
//       if (!uniqueId) return;

//       const variant = getVariantFromControl(control);
//       updateSitewideSalePrices(variant, uniqueId);
//     });
//   }

//   function handleVariantChange(event) {
//     const control = event.target;
//     const variant = event.detail?.variant || getVariantFromControl(control);
//     const uniqueId = control.dataset.card || control.dataset.section;

//     if (!variant || !uniqueId) return;

//     setTimeout(() => updateSitewideSalePrices(variant, uniqueId), 0);
//   }

//   document.addEventListener('on:variant:change', handleVariantChange, true);

//   function init() {
//     syncProductPagePrices();
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   setTimeout(init, 0);
//   setTimeout(init, 100);
//   setTimeout(init, 500);
// }


import { formatMoney } from 'utils';

if (window.theme?.sitewide_sale_enabled) {
  const percentage = window.theme.sitewide_sale_percentage || 0;

  function calculateSalePrice(price) {
    return Math.round(price - (price * percentage) / 100);
  }

  function buildPdpPriceHTML(variant) {
    const salePrice = calculateSalePrice(variant.price);
    const saleFormatted = formatMoney(salePrice, window.theme.money_product_price_format);
    const originalFormatted = formatMoney(variant.price, window.theme.money_product_price_format);

    return `
      <span class="u-hidden-visually">${window.theme.localize('REGULAR_PRICE')}</span>
      <span class="price__number price__number--sale">
        <span class="money">${saleFormatted}</span>
      </span>
      <span class="u-hidden-visually">${window.theme.localize('SALE_PRICE')}</span>
      <s class="price__compare">
        <span class="money">${originalFormatted}</span>
      </s>
    `;
  }

  function updateSitewideSalePrices(variant, uniqueId) {
    if (!variant) return;

    const saleHTML = buildPdpPriceHTML(variant);
    const saleFormatted = formatMoney(calculateSalePrice(variant.price), window.theme.money_product_price_format);

    document.querySelectorAll(`#price-${uniqueId}, [id="price-${uniqueId}"]`).forEach((priceEl) => {
      priceEl.innerHTML = saleHTML;
    });

    document.querySelectorAll('.price-new-wrap .price-atc-wrap').forEach((el) => {
      el.textContent = saleFormatted;
    });

    document.querySelectorAll('.title-price-on-top-wrapper .price__number .money').forEach((el) => {
      el.textContent = saleFormatted;
    });

    const stickyPrice = document.querySelector('.sticky-atc .sticky-price .price');
    const stickyCompare = document.querySelector('.sticky-atc .sticky-price .compare');
    const originalFormatted = formatMoney(variant.price, window.theme.money_product_price_format);

    if (stickyPrice) {
      stickyPrice.textContent = saleFormatted;
    }

    if (stickyCompare) {
      stickyCompare.textContent = originalFormatted;
    }
  }

  function getVariantFromControl(control) {
    if (typeof control.getVariantData !== 'function') return null;

    const variants = control.getVariantData();
    if (!variants?.length) return null;

    if (typeof control.currentVariant !== 'undefined' && control.currentVariant) {
      return control.currentVariant;
    }

    const options = Array.from(control.querySelectorAll('select')).map((select) => select.value);
    if (options.length) {
      return variants.find((variant) => !variant.options.map((value, index) => options[index] === value).includes(false));
    }

    const fieldsets = Array.from(control.querySelectorAll('fieldset'));
    if (fieldsets.length) {
      const selectedOptions = fieldsets.map(
        (fieldset) => Array.from(fieldset.querySelectorAll('input')).find((input) => input.checked)?.value,
      );
      return variants.find(
        (variant) => !variant.options.map((value, index) => selectedOptions[index] === value).includes(false),
      );
    }

    return variants.find((variant) => variant.available) || variants[0];
  }

  function syncProductPagePrices() {
    document.querySelectorAll('variant-selects, variant-radios, variant-mixed-inputs').forEach((control) => {
      const uniqueId = control.dataset.card || control.dataset.section;
      if (!uniqueId) return;

      const variant = getVariantFromControl(control);
      updateSitewideSalePrices(variant, uniqueId);
    });
  }

  function handleVariantChange(event) {
    const control = event.target;
    const variant = event.detail?.variant || getVariantFromControl(control);
    const uniqueId = control.dataset.card || control.dataset.section;

    if (!variant || !uniqueId) return;

    setTimeout(() => updateSitewideSalePrices(variant, uniqueId), 0);
  }

  document.addEventListener('on:variant:change', handleVariantChange, true);

  function init() {
    syncProductPagePrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setTimeout(init, 0);
  setTimeout(init, 100);
  setTimeout(init, 500);
}
